import * as React from 'react';

import styled from '@emotion/styled';

import { Header } from 'bundles/enterprise-ui/components';

const Overlay = styled.div({
  position: 'absolute',
  zIndex: 3000,
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  backgroundColor: 'var(--cds-color-neutral-background-primary-weak)',
});

export default ({ children }: { children: React.ReactNode }) => (
  <Overlay>
    <Header />
    {children}
  </Overlay>
);
